if (!customElements.get('sd-thumbnail-scroll')) {
  customElements.define('sd-thumbnail-scroll', class extends HTMLElement {
    connectedCallback() {
      this.rail = this.closest('carousel-slider');
      this.gallery = this.closest('media-gallery');
      this.scroller = this.rail.querySelector('.slider');
      this.grid = this.scroller.querySelector('.slider__grid');
      this.main = this.gallery.querySelector('.main-image');
      this.up = this.querySelector('[data-direction="up"]');
      this.down = this.querySelector('[data-direction="down"]');
      this.desktop = window.matchMedia('(min-width: 1041px)');
      this.refresh = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.update());
      };
      this.onClick = event => {
        const button = event.target.closest('button');
        if (!button || button.disabled) return;
        const direction = button.dataset.direction === 'up' ? -1 : 1;
        this.scroller.scrollBy({top: direction * this.scroller.clientHeight * .75,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      };
      this.onMediaChange = () => {
        this.refresh();
        if (!this.isVertical()) return;
        const active = this.grid.querySelector('.is-active:not([hidden])');
        if (!active) return;
        const item = active.getBoundingClientRect();
        const rail = this.scroller.getBoundingClientRect();
        if (item.top < rail.top) this.scroller.scrollTop += item.top - rail.top;
        else if (item.bottom > rail.bottom) this.scroller.scrollTop += item.bottom - rail.bottom;
      };
      this.addEventListener('click', this.onClick);
      this.scroller.addEventListener('scroll', this.refresh, {passive:true});
      window.addEventListener('resize', this.refresh, {passive:true});
      this.resizeObserver = new ResizeObserver(this.refresh);
      this.resizeObserver.observe(this.main);
      this.resizeObserver.observe(this.grid);
      this.mutationObserver = new MutationObserver(this.onMediaChange);
      this.mutationObserver.observe(this.grid, {subtree:true, attributes:true, attributeFilter:['class','hidden']});
      this.refresh();
    }
    isVertical() {
      return this.desktop.matches && this.gallery.classList.contains('media-gallery--layout-carousel-beside');
    }
    update() {
      if (!this.isVertical()) {
        this.rail.classList.remove('sd-thumbnails-overflow');
        return;
      }
      const height = Math.max(200, Math.min(this.main.clientHeight || 560, window.innerHeight - 160, 680));
      this.rail.style.setProperty('--sd-thumbnail-height', `${height}px`);
      const overflow = this.grid.scrollHeight > height - 64;
      this.rail.classList.toggle('sd-thumbnails-overflow', overflow);
      this.up.disabled = this.scroller.scrollTop <= 2;
      this.down.disabled = this.scroller.scrollTop + this.scroller.clientHeight >= this.scroller.scrollHeight - 2;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.resizeObserver?.disconnect();
      this.mutationObserver?.disconnect();
      window.removeEventListener('resize', this.refresh);
      this.scroller?.removeEventListener('scroll', this.refresh);
      this.removeEventListener('click', this.onClick);
    }
  });
}
